// extracted by mini-css-extract-plugin
export default {"latestNewsSection":"Amazing_latestNewsSection__LjdZT","heading":"Amazing_heading__FhRRU","newsImage":"Amazing_newsImage__-c7+M","content":"Amazing_content__YTwBu"};